import React from 'react';
import { motion } from 'framer-motion';
import './PolicyPage.css';

const TermsConditions = () => {
  return (
    <section className="policy-page section">
      <div className="container">
        <motion.div 
          className="policy-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>📜 Terms & Conditions</h1>
          <p className="last-updated">Last updated: June 11, 2025</p>
          
          <p>These Terms govern your use of www.digitalfig.com.</p>

          <h2>1. Who we are</h2>
          <p>www.digitalfig.com is operated by Ctrl Digital Tech Ltd, registered in England (Company No 15889833), based at 350 Hoe Street, London E17 9PX.</p>

          <h2>2. Acceptance of terms</h2>
          <p>By using the Site, you agree to these Terms. If you disagree, please discontinue use.</p>

          <h2>3. Use of the Site</h2>
          <ul>
            <li>You may use the Site only for lawful purposes.</li>
            <li>You agree not to violate any laws or infringe on others' rights.</li>
            <li>Content belongs to us unless stated otherwise and may not be reproduced without permission.</li>
          </ul>

          <h2>4. Advertising & enquiries</h2>
          <p>We may offer advertising across our network. For details or bookings, please email <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a>.</p>

          <h2>5. Content disclaimers</h2>
          <ul>
            <li>The Site is provided "as is" without warranty of any kind.</li>
            <li>We are not liable for any loss or damage arising from your use of the Site.</li>
          </ul>

          <h2>6. Limitation of liability</h2>
          <p>To the fullest extent permitted by law, Ctrl Digital Tech Ltd is not liable for indirect or consequential losses.</p>

          <h2>7. Indemnity</h2>
          <p>You agree to indemnify us against any third-party claims arising from your use of the Site.</p>

          <h2>8. Changes</h2>
          <p>We may revise these Terms at any time. Revised terms take effect from posting.</p>

          <h2>9. Governing law</h2>
          <p>These Terms are governed by the laws of England and Wales. Disputes are handled by courts of England and Wales.</p>

          <h2>10. Contact</h2>
          <p>For questions about these Terms, email <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a></p>
        </motion.div>
      </div>
    </section>
  );
};

export default TermsConditions;